import { useLocalStorage } from "@src/appV2/lib/utils";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

function getPlacementDetailsReferralViewCountStorageKey(workerId: string) {
  return `viewed-placement-details-referral-count-${workerId}`;
}

export function usePlacementDetailReferralViewCountStorage() {
  const worker = useDefinedWorker();

  const [placementDetailsReferralViewCount, setPlacementDetailsReferralViewCount] =
    useLocalStorage<number>(getPlacementDetailsReferralViewCountStorageKey(worker.userId), 0);

  return { placementDetailsReferralViewCount, setPlacementDetailsReferralViewCount };
}
